"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_property_decorator_1 = require("vue-property-decorator");
const bmk_ui_framework_1 = require("@biomemakers/bmk_ui_framework");
const RedirectionService_1 = __importDefault(require("../class/services/RedirectionService"));
const EventTracker_1 = __importDefault(require("@becrop/abstract/Utils/EventTracker"));
let WidgetHelp = class WidgetHelp extends vue_property_decorator_1.Vue {
    constructor() {
        super(...arguments);
        this.redirectionService = new RedirectionService_1.default();
        this.eventTracker = new EventTracker_1.default();
    }
    eventTrackerListener(eventName, eventValues) {
        this.eventTracker.trackEvent(eventName, eventValues);
    }
    redirection(param) {
        this.redirectionService.helpCenterOpen(param);
        this.eventTrackerListener('goHelpCenter', { param: param });
    }
    get placeholder() {
        return 'i.e. BeCrop, Trials';
    }
    get title() {
        return this.$trans('dashboard_single.help.title');
    }
    get subtitle() {
        return this.$trans('dashboard_single.help.sub');
    }
};
WidgetHelp = __decorate([
    (0, vue_property_decorator_1.Options)({
        components: {
            InputAction: bmk_ui_framework_1.InputAction,
        },
    })
], WidgetHelp);
exports.default = WidgetHelp;
